import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyAnLT24xYgem0DJquUT71mykxCpbr2KY0s",
    authDomain: "slack-clone-pr-e298e.firebaseapp.com",
    projectId: "slack-clone-pr-e298e",
    storageBucket: "slack-clone-pr-e298e.appspot.com",
    messagingSenderId: "823409077294",
    appId: "1:823409077294:web:12bf42432cf29b1ee3c3bf"
  };

  const firebaseapp = firebase.initializeApp(firebaseConfig);
  const db = firebaseapp.firestore();
  const auth = firebase.auth();
  const provider  = new firebase.auth.GoogleAuthProvider();

  export{auth,provider,db};